import * as FilePond from 'filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

FilePond.registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginImageExifOrientation,
    FilePondPluginFileValidateSize,
    FilePondPluginImageEdit,
    FilePondPluginFileValidateType
);

export class FileDrop extends HTMLInputElement {

    constructor() {
        super();
    }

    connectedCallback() {
        let files = [];

        if (this.dataset.files && this.dataset.files !== "") {
            files.push({
                source: this.dataset.files,
                options: {
                    type: 'input',
                },
            })
        }

        this.file = FilePond.create(
            this, {
                labelIdle: 'Faites glisser et déposez ' + this.dataset.label.toLowerCase() + ' ou <span class="filepond--label-action"> Parcourir </span>',
                storeAsFile: true,
                files: files,
                name: this.name,
                labelMaxFileSizeExceeded: 'Le fichier est trop grand',
                labelMaxFileSize: 'La taille maximale du fichier est de {filesize}',
                labelMaxTotalFileSizeExceeded: 'Taille totale maximale dépassée',
                labelMaxTotalFileSize: 'La taille totale maximale du fichier est de {filesize}'
            }
        );
    }

    disconnectedCallback() {
        FilePond.destroy(this.file)
    }
}


export class FileProfileDrop extends HTMLInputElement {

    constructor() {
        super();
    }

    connectedCallback() {
        let files = [];

        if (this.dataset.files && this.dataset.files !== "") {
            files.push({
                source: this.dataset.files,
                options: {
                    type: 'input',
                },
            })
        }

        this.file = FilePond.create(
            this, {
                labelIdle: 'Faites glisser et déposez votre photo ou <span class="filepond--label-action"> Parcourir </span>',
                storeAsFile: true,
                files: files,
                name: this.name,
                imagePreviewHeight: 170,
                imageCropAspectRatio: '1:1',
                imageResizeTargetWidth: 200,
                imageResizeTargetHeight: 200,
                stylePanelLayout: 'compact circle',
                styleLoadIndicatorPosition: 'center bottom',
                styleProgressIndicatorPosition: 'right bottom',
                styleButtonRemoveItemPosition: 'left bottom',
                styleButtonProcessItemPosition: 'right bottom',
                labelMaxFileSizeExceeded: 'Le fichier est trop grand',
                labelMaxFileSize: 'La taille maximale du fichier est de {filesize}',
                labelMaxTotalFileSizeExceeded: 'Taille totale maximale dépassée',
                labelMaxTotalFileSize: 'La taille totale maximale du fichier est de {filesize}'
            }
        );
    }

    disconnectedCallback() {
        FilePond.destroy(this.file)
    }
}

